import * as types from "../actions/ActionTypes"

export const setPanel = (panel) => ({type: types.SET_PANEL, payload: panel});